import { render } from "./RegistrationInfoPage.vue?vue&type=template&id=10bef112"
import script from "./RegistrationInfoPage.vue?vue&type=script&lang=js"
export * from "./RegistrationInfoPage.vue?vue&type=script&lang=js"

import exportComponent from "G:\\deploy\\cfan\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__